import React from 'react'
import { useForm } from 'react-hook-form'
import { IItem } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'

const LocationForm: React.FC<LocationFormProps> = ({
  onSubmit,
  onDelete,
  useType = 'create',
  defaultValues,
  submitting,
  onClose,
}) => {
  const form = useForm<IItem>({ defaultValues: useType === 'create' ? {} : { ...defaultValues } })

  const options = [
    { text: 'PRODUCCIÓN', value: 'PRODUCTION' },
    { text: 'ALMACÉN', value: 'WAREHOUSE' },
  ]

  return (
    <div>
      <Form
        classes="gap-x-6"
        form={form}
        onSubmit={(values) => {
          form?.reset()
          onSubmit({ ...values, warehouseType: "WAREHOUSE", id: defaultValues?.id })
        
        }}
        style={{ width: '100%' }}
      >
        <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-6 col-span-12">
          {useType === 'create' ? 'Añadir Almacén' : 'Editar Almacén'}
        </h1>
        <h3 className='font-bold text-gray-400 col-span-12 text-xs mb-3'>{defaultValues?.name}</h3>
        {/* {useType === 'create' && (
          <FormItem
            name="warehouseType"
            classes="xl:col-span-4 col-span-12"
            rules={{
              required: 'Es necesario que seleccione el tipo de ubicación',
            }}
          >
            <Select
              options={options}
              label="Tipo de Almacén"
              placeholder="Seleccione tipo de almacén"
              containerClasses="w-full"
            />
          </FormItem>
        )} */}
        <FormItem
          name="name"
          classes={`${
            useType === 'edit' ? 'xl:col-span-12' : 'xl:col-span-12'
          } col-span-12`}
          rules={{ required: 'Es necesario el nombre' }}
        >
          <InputText small label="Nombre" maxLength={30} />
        </FormItem>
        {/* <FormItem name='manager' classes='col-span-3'>
        <InputText small label='Manager'/>
      </FormItem> */}
        <FormItem
          name="description"
          classes="col-span-12 mb-6"
          rules={{ required: 'Es necesaria la descripción' }}
        >
          <InputText small label="Descripción" maxLength={250} />
        </FormItem>
        {onClose && (
          <Button
            type="outline"
            classes="col-span-6 ml-1"
            onClick={() => {
              onClose()
              form?.reset()
            }}
            htmlType="button"
          >
            Cancelar
          </Button>
        )}
        <Button
          classes="col-span-6 mr-1"
          type="primary"
          loading={submitting}
          htmlType="submit"
        >
          {useType === 'create' ? 'Registrar' : 'Guardar'}
        </Button>

        {/* <div className="col-span-12 h-full flex justify-end">
        {useType === 'edit' && <Button onClick={() => { if(onDelete) onDelete(defaultValues); }} type='primary' danger loading={submitting} small={useType === 'edit'} classes='mr-1' icon={<IoCloseSharp/>}>Eliminar</Button>}
        <Button type='primary' loading={submitting} small={useType === 'edit'} htmlType='submit' icon={<BiSave/>}>{useType === 'create' ? 'Finalizar' : 'Guardar'}</Button>
      </div> */}
      </Form>
    </div>
  )
}

export default LocationForm

interface LocationFormProps {
  onSubmit: Function
  onDelete?: Function
  useType?: 'create' | 'edit'
  defaultValues?: object | any
  submitting?: boolean
  onClose?: Function
}
